export default function loadScript(src: string) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', () => {
            resolve();
        });
        script.addEventListener('error', e => {
            reject(e);
        });
        document.body.appendChild(script);
    });
}

export function appendScript(children: any, ref?: HTMLSpanElement | null) {
    const script = document.createElement('script');
    script.innerHTML = children;

    if (ref) {
        ref.appendChild(script);
    } else {
        document.body.appendChild(script);
    }
}
